export const strings = {
  NOTHING_TO_SUBMIT: "Nothing to submit",
  INCOMPLETE_FIELDS: "Some fields are incomplete",
  SELECT_BILLING_PERIOD: "Need to select a billing period",
  DOWNLOAD_SUCCESS: "Downloaded billing CSV",
  NO_BILLING_DATA: "There is no billing data for that period",
  DOWNLOAD_FAILURE: "Failed to download billing CSV",
  TITLE: "Export billing for all model portfolios",
  DESCRIPTION: "Select a month to download a CSV for all model portfolios.",
  CANCEL_BUTTON: "Cancel",
  DOWNLOAD_CSV_BUTTON: "Download CSV",
  MONTH_LABEL: "Month",
  MONTH_REQUIRED: "Must not be empty",
  MONTH_PLACEHOLDER: "Select month",
} as const;
